import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Grid, TextField, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton } from '@mui/material';
import i18next from 'i18next';
import auth from '@/apis/auth';
import { makeStyles } from '@mui/styles';
import { CloseOutlined } from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({
  profilePhoto: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  profileContent: {
    padding: '25px 16px 12px 16px'
  },
  sitesTitle: {
    fontSize: '1.25rem',
    fontWeight: 600,
  },
  Dialogtitle: {
    background:'rgba(239, 89, 39, 0.12)'
  },
  Dialogcontent:{
    padding: '0px'
  },
  DialogActionbtn: {
    marginTop: '14px',
  },
  ButtonStyle: {
    height: '40px',
    color: 'white',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '4px',
    marginRight: '9px'
  },
  closeIconBtn: {
    position: 'absolute',
    right: 12,
    top: 8,
    padding: 4
  }
}));

interface UserProfileProps {
  open: boolean;
  onClose: () => void;
}

const UserProfile: React.FC<UserProfileProps> = ({ open, onClose }) => {
  const [userProfile, setUserProfile] = useState<any>(null);
  const classes = useStyles();

  const fetchUserProfile = async () => {
    try {
      const response = await auth.userProfile();
      setUserProfile(response.data);
    } catch (error) {
      console.error('Error fetching user profile:', error);
    }
  };

  useEffect(() => {
    if (open && !userProfile) {
      fetchUserProfile();
    }
  }, [open, userProfile]);
  const sites = userProfile?.sites || [];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle className={classes.Dialogtitle}>{i18next.t('common:settings.profileheader')}
        <IconButton
          aria-label="close"
          onClick={onClose}
          className={classes.closeIconBtn}
        >
          <CloseOutlined style={{color:'#000000'}}/>
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.Dialogcontent}>
        <Grid container>
          <Grid item xs={12}>
            <div className={classes.profileContent}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    id="outlined-read-only-input-first-name"
                    label={i18next.t('common:settings.firstName')}
                    value={userProfile?.first_name || ''}
                    variant="outlined"
                    inputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    id="outlined-read-only-input-last-name"
                    label={i18next.t('common:settings.lastName')}
                    value={userProfile?.last_name || ''}
                    variant="outlined"
                    inputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} style={{ marginTop: '20px' }}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    id="outlined-read-only-input-company-name"
                    label={i18next.t('common:settings.companyName')}
                    value={userProfile?.company_name || ''}
                    variant="outlined"
                    inputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    id="outlined-read-only-input-active-role"
                    label={i18next.t('common:settings.activeRole')}
                    value={userProfile?.active_role || ''}
                    variant="outlined"
                    inputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} style={{ marginTop: '20px' }}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    id="outlined-read-only-input-active-site-name"
                    label={i18next.t('common:settings.activeSiteName')}
                    value={userProfile?.active_site_name || ''}
                    variant="outlined"
                    inputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    id="outlined-read-only-input-email"
                    label={i18next.t('common:settings.email')}
                    value={userProfile?.email || ''}
                    variant="outlined"
                    inputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} style={{ marginTop: '20px' }}>
                <Grid item xs={12} sm={6} style={{ paddingTop: '0px' }}>
                  {sites.length === 0 ? (
                    <TextField
                      fullWidth
                      label={i18next.t('common:settings.sites')}
                      value={i18next.t('common:settings.noSitesAvailable')}
                      variant="outlined"
                      inputProps={{ readOnly: true }}
                      InputLabelProps={{ shrink: true }}
                    />
                  ) : (
                    <>
                      <Typography variant="h6" className={classes.sitesTitle}>
                        {i18next.t('common:settings.sites')}
                      </Typography>
                      <Grid container style={{ marginTop: '20px' }}>
                        <TableContainer component={Paper}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell>
                                  <strong>{i18next.t('common:settings.siteName')}</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>{i18next.t('common:settings.siterole')}</strong>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {sites.map((site: any, index: any) => (
                                <TableRow key={index}>
                                  <TableCell>{site.name}</TableCell>
                                  <TableCell>{site.role}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className={classes.DialogActionbtn}>
      </DialogActions>
    </Dialog>
  );
};

export default UserProfile;
